import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { fullReset } from "@/store/actions";

export const useUserResetEffect = () => {
    const userId = useAppSelector((s) => s.user.id);

    const dispatch = useAppDispatch();

    useEffect(() => {
        const previousUserId = localStorage.getItem("prevUserId");

        if (!userId || previousUserId === userId) return;

        localStorage.setItem("prevUserId", userId);
        dispatch(fullReset());
    }, [dispatch, userId]);
};
